export const leaveDashboardStyle = {
  leaveDetailsTabWrapper: {
    padding: 0,
    border: '0.125rem solid ',
    borderColor: 'neutral.300',
    borderRadius: '0.75rem',
    backgroundColor: 'common.white',
  },
};
